import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxSignatureComponent } from './rx-signature.component';

@NgModule({
  imports: [CommonModule, RxSignatureComponent],
  exports: [RxSignatureComponent, RxSignatureComponent],
})
export class RxSignatureModule {}
